export var CheckoutStepsEnum;
(function (CheckoutStepsEnum) {
    CheckoutStepsEnum["ADDITIONAL_DETAILS"] = "ADDITIONAL_DETAILS";
    CheckoutStepsEnum["CUSTOMER_DETAILS"] = "CUSTOMER_DETAILS";
    CheckoutStepsEnum["SHIPPING_DETAILS"] = "SHIPPING_DETAILS";
    CheckoutStepsEnum["DELIVERY_METHOD"] = "DELIVERY_METHOD";
    CheckoutStepsEnum["PAYMENT"] = "PAYMENT";
    CheckoutStepsEnum["REVIEW_AND_PLACE_ORDER"] = "REVIEW_AND_PLACE_ORDER";
    CheckoutStepsEnum["CLOSED"] = "CLOSED";
})(CheckoutStepsEnum || (CheckoutStepsEnum = {}));
export const checkoutSteps = [
    'ADDITIONAL_DETAILS',
    'CUSTOMER_DETAILS',
    'SHIPPING_DETAILS',
    'DELIVERY_METHOD',
    'PAYMENT',
    'REVIEW_AND_PLACE_ORDER',
];
export let checkoutStepsSubmitStatus = {};
for (const key in CheckoutStepsEnum) {
    if (isNaN(Number(key))) {
        checkoutStepsSubmitStatus = {
            ...checkoutStepsSubmitStatus,
            [key]: false,
        };
    }
}
export const nextStep = (current, hasInventory = false) => {
    const currIdx = checkoutSteps.indexOf(current);
    // If current isn't in the list (shouldn't happen), go to first step.
    if (currIdx === -1)
        return checkoutSteps[0];
    const advanceBy = 1;
    const nextIdx = currIdx + advanceBy;
    return nextIdx < checkoutSteps.length ? checkoutSteps[nextIdx] : 'CLOSED';
};
